<template>
  <div class="fees-list">
    <div
      v-if="loadingFees"
      class="text-center py-2 px-1"
    >
      <b-spinner large />
    </div>
    <b-row>
      <b-col
        v-for="(method, idx) in paymentMethods"
        :key="idx"
        lg="4"
        md="6"
        sm="12"
      >
        <fee-card
          :currency="currency"
          :fee="method"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BSpinner } from 'bootstrap-vue'
import TransactionsAPIs from '@/API/ordering/transactions-api'
import FeeCard from '@/views/admin/purchase/components/FeeCard'

const VISA_LOGO_LIGHT = require('@/assets/images/payment/payment-methods/light/visa.png')
const MASTER_LOGO_LIGHT = require('@/assets/images/payment/payment-methods/light/master.png')
const AMEX_LOGO_LIGHT = require('@/assets/images/payment/payment-methods/light/amex.png')
const KNET_LOGO_LIGHT = require('@/assets/images/payment/payment-methods/light/knet.png')
const BENEFIT_LOGO_LIGHT = require('@/assets/images/payment/payment-methods/light/benefit.png')

export default {
  name: 'FeesList',
  components: {
    FeeCard, BRow, BCol, BSpinner,
  },
  data() {
    return {
      loadingFees: false,
      fees: {},
    }
  },
  computed: {
    currency() {
      return this.$store.getters['branches/currentBranch']?.currency
    },
    paymentMethods() {
      return Object.keys(this.fees).map(methodKey => ({ method: methodKey, ...this.fees[methodKey], logo: this.getLogo(methodKey) }))
    },
  },
  watch: {
    currency() {
      this.getFees()
    },
  },
  mounted() {
    this.getFees()
  },
  methods: {
    getFees() {
      this.loadingFees = true
      TransactionsAPIs.getPaymentMethodsFees(this.currency)
        .then(fees => { this.fees = fees })
        .catch(err => this.$notifyError(err))
        .finally(() => { this.loadingFees = false })
    },
    getLogo(method) {
      switch (method) {
        case 'visa': return VISA_LOGO_LIGHT
        case 'master': return MASTER_LOGO_LIGHT
        case 'amex': return AMEX_LOGO_LIGHT
        case 'benefit': return BENEFIT_LOGO_LIGHT
        case 'knet': return KNET_LOGO_LIGHT
        default: return ''
      }
    },
  },
}
</script>

<style lang="scss">
.fees-list {
  margin-top: 16px;
}
</style>
